import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { ActionBtnComponent } from 'src/app/shared/components/master-detail-layout/action-btn/action-btn.component';
import { CardComponent } from 'src/app/shared/components/master-detail-layout/card/card.component';
import { PrinterFormService } from '../../../services/printer-form.service';
import { PrintersModuleService } from '../../../services/printers-module.service';
import { PrintersFormGroups } from '../../../models/settings-printers.model';
import { Printers } from 'tilby-models';

@Component({
  selector: 'app-printer-non-fiscal-configuration',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    ActionBtnComponent,
    MatFormFieldModule, ReactiveFormsModule,
    MatSlideToggleModule, MatCheckboxModule,
    TranslateModule
  ],
  templateUrl: './printer-non-fiscal-configuration.component.html',
  styleUrl: './printer-non-fiscal-configuration.component.scss'
})
export class PrinterNonFiscalConfigurationComponent {
  
  protected readonly printerFormService = inject(PrinterFormService);  
  private readonly printerModuleService = inject(PrintersModuleService);
  
  protected printerGroupForm!: PrintersFormGroups;
  protected printer: Printers | null = null;

  protected linearLabelClass = "tw-font-medium tw-text-[var(--sys-secondary-text)]";
  protected linearValueClass = "tw-font-medium tw-text-[var(--sys-text)]";
  protected subTitleClass = "tw-text-sm tw-font-bold tw-text-[var(--sys-secondary-text)] tw-mb-1";
  protected priceValueClass = "tw-text-sm tw-font-medium tw-text-[var(--sys-text)]";

  constructor() {
    effect(() => {
      if(this.printerFormService.printerFormReady()) {
        this.printerGroupForm = this.printerFormService.form;
      }
    })
    effect(() => {
      this.printer = this.printerModuleService.selection()?.printer as Printers;
    })
  }

  toggleAllCategories() {
    const allSelected = this.printerFormService.allCategories?.value;
    
    this.printerFormService.categoriesArray?.controls.forEach((control: any) => {
      control.get('checked')?.setValue(allSelected);
    });
  }

  onSingleCategoryChange() {
    const allChecked = this.printerFormService.categoriesArray?.controls.every((ctrl: any) => ctrl.get('checked')?.value);
    
    this.printerFormService.allCategories?.setValue(allChecked, { emitEvent: false });
  }


  toggleAllRooms() {
    const allSelected = this.printerFormService.allRooms?.value;
    
    this.printerFormService.roomsArray?.controls.forEach((control: any) => {
      control.get('checked')?.setValue(allSelected);
    });
  }

  onSingleRoomChange() {
    const allChecked = this.printerFormService.roomsArray?.controls.every((ctrl: any) => ctrl.get('checked')?.value);
    
    this.printerFormService.allRooms?.setValue(allChecked, { emitEvent: false });
  }


  toggleAllCashregisters() {
    const allSelected = this.printerFormService.allCashregisters?.value;
    
    this.printerFormService.cashregistersArray?.controls.forEach((control: any) => {
      control.get('checked')?.setValue(allSelected);
    });
  }

  onSingleCashregisterChange() {
    const allChecked = this.printerFormService.cashregistersArray?.controls.every((ctrl: any) => ctrl.get('checked')?.value);
    
    this.printerFormService.allCashregisters?.setValue(allChecked, { emitEvent: false });
  }


  toggleAllOtherPrinters() {
    const allSelected = this.printerFormService.allOtherPrinters?.value;
    
    this.printerFormService.otherPrintersArray?.controls.forEach((control: any) => {
      control.get('checked')?.setValue(allSelected);
      if(allSelected) {
        control.get('inline')?.enable();
      } else {
        control.get('inline')?.disable();
      }
    });
  }

  onSinglePrinterChange(index: number) {
    const allChecked = this.printerFormService.otherPrintersArray?.controls.every((ctrl: any) => ctrl.get('checked')?.value);
    
    this.printerFormService.allOtherPrinters?.setValue(allChecked, { emitEvent: false });

    if(this.printerFormService.otherPrintersArray?.at(index).get('checked')?.value) {
      this.printerFormService.otherPrintersArray?.at(index).get('inline')?.enable();
    } else {
      this.printerFormService.otherPrintersArray?.at(index).get('inline')?.disable();
    }
  }
}
